<section
  [ngClass]="usuarioB.temaModelo == 'ROSA' ? 'background-rosa': 'background-azul'"
>
  <div class="logo">
    <a routerLink="">
    <img src="assets/images/JOTA%20LOGO-02-02.svg" alt="logo da jota sales"></a>
    <div class="texto-logo">
      <span class="versao">versão {{versao}}</span>
    </div>
  </div>

  <div class="actions">
    <app-notifications></app-notifications>
    <app-user-details></app-user-details>
  </div>
</section>
